const secrets = {
    third_party_token_set: {
        token_not_found: 'لم يتم العثور على سجل الرمز.',
        access_token_expired: 'انتهت صلاحية رمز الوصول. يرجى إعادة توصيل حسابك.',
    },
};
export default Object.freeze(secrets);
